export default "__VITE_ASSET__BCalB2z5__"